import React, { forwardRef } from 'react';
import { Typo, Icon } from '@ers/ui/';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useClickOutside } from '@ers/hooks';
import Portal from './Portal';

const Modal = forwardRef(({ title, close, condition, children }, outerRef) => {
    const ref = useClickOutside(close, condition);
    return (
        <Portal>
            <ModalBackground ref={outerRef}>
                <ModalBody ref={ref}>
                    <ModalHeader>
                        {title && (
                            <Typo.Title>
                                {title}
                            </Typo.Title>
                        )}
                        <Icon name="close" className="modal__header--ico" onClick={close} />
                    </ModalHeader>
                    {children}
                </ModalBody>
            </ModalBackground>
        </Portal>
    );
});

const ModalBackground = forwardRef(({ children }, ref) => (
    <div className="modal__bg" ref={ref}>
        {children}
    </div>
));
const ModalBody = forwardRef(({ children }, ref) => (
    <div className="modal" ref={ref}>
        {children}
    </div>
));
const ModalHeader = ({ children }) => (
    <div className={cx('modal__header', 'with-margin--bottom-4')}>
        {children}
    </div>
);
const ModalFooter = ({ children }) => (
    <div className={cx('modal__footer', 'with-margin--top-4')}>
        {children}
    </div>
);
Modal.Background = ModalBackground;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

Modal.propTypes = {
    close: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    condition: PropTypes.bool
};

Modal.defaultProps = {
    condition: true,
    title: null
};

export default Modal;